import { CustomerAppendsApi } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('CustomerAppendStore')

const CustomerAppendsStore = {
  namespaced: true,
  state: {
    customerAppends: []
  },
  mutations: {
    saveAppends: (state, payload) => (state.customerAppends = payload.data)
  },
  actions: {
    getCustomerAppends ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        CustomerAppendsApi.get(payload.customer_id)
          .then(response => {
            commit('saveAppends', response)
            resolve(state.customerAppends)
          })
          .catch(error => {
            logger.error('Error fetching customer appends', error.message)
            reject(error)
          })
      })
    },
    saveCustomerAppends ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        CustomerAppendsApi.create(payload)
          .then(response => {
            // the response returns full customer appends
            commit('saveAppends', response)
            resolve(state.customerAppends)
          })
          .catch(error => {
            logger.error('Error saving customer appends', error.message)
            reject(error)
          })
      })
    }
  },
  getters: {
  }
}

export default CustomerAppendsStore
